// extracted by mini-css-extract-plugin
export default {"allLicense":"AllLicense_allLicense__EcrcA"};